import { connect } from 'react-redux';
import { getDuperbrowseNavigation, getIsDuperbrowseActive, getPreloadingEnabled, getRootStream } from '../../../Duperbrowse/redux/selectors';
import { movePrev, moveNext } from '../../../Duperbrowse/redux/actionCreators';
import { getIsDuperbrowseAllowed, getRelatedContentLoadingState } from '../../../DeviationPage/redux/selectors';
import { fetchRelatedContentForDeviation } from '../../../DeviationPage/redux/actions';
const mapStateToProps = (state, ownProps)=>{
    var _getRootStream_items, _getRootStream;
    return {
        isEnabled: getIsDuperbrowseAllowed(state),
        navigation: getDuperbrowseNavigation(state),
        duperActive: getIsDuperbrowseActive(state),
        preloadEnabled: getPreloadingEnabled(state),
        hasRootStream: ((_getRootStream = getRootStream(state)) === null || _getRootStream === void 0 ? void 0 : (_getRootStream_items = _getRootStream.items) === null || _getRootStream_items === void 0 ? void 0 : _getRootStream_items.length) > 1,
        relatedLoadingState: getRelatedContentLoadingState(state, ownProps.deviation)
    };
};
const mapDispatchToProps = {
    moveNext,
    movePrev,
    fetchRelatedContentForDeviation
};
export default connect(mapStateToProps, mapDispatchToProps);
